import { StrictMode } from 'react';

import { ApolloProvider } from '@apollo/client';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { factory } from 'api/apollo';
import { App } from 'components/tools';
import { TranslationsContextProvider } from 'context/translations';
import { store, persistor } from 'redux/store';
import { sentry, gtm } from 'utils';

import 'lib/fullcalendar';
import 'react-dates/initialize';

import 'styles/_global.scss';
import 'styles/_cssModuleOrderWorkaround';

gtm.init();
sentry.init();

const rootElement = document.getElementById('root');

if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <TranslationsContextProvider>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <ApolloProvider client={factory(store)}>
              <HelmetProvider>
                <App />
              </HelmetProvider>
            </ApolloProvider>
          </PersistGate>
        </Provider>
      </TranslationsContextProvider>
    </StrictMode>
  );
}
